import script from "./CardImage.vue?vue&type=script&setup=true&lang=ts"
export * from "./CardImage.vue?vue&type=script&setup=true&lang=ts"

import "./CardImage.vue?vue&type=style&index=0&id=5eb87702&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5eb87702"]])

export default __exports__